import { Subject } from "../types/types";
import { getErrorMessage, privateApiClient } from "../utils/axios.utils";

interface CreateSubjectPayload {
  code: string;
  name: string;
  exam_category_ids: number[];
}

interface UpdateSubjectPayload {
  id: number;
  code: string;
  name: string;
  exam_category_ids: number[];
}

class SubjectService {
  /**
   * Fetch subjects for an exam category.
   */
  async getSubjects(examCategoryId: number): Promise<Subject[]> {
    try {
      const response = await privateApiClient.get<{
        data: { data: Subject[] };
        message: string;
        success: boolean;
      }>(`/subjects/category/${examCategoryId}`, {
        params: { exam_category_id: examCategoryId },
      });
      return response.data.data.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  }

  /**
   * Create multiple subjects in batch.
   */
  async batchCreate(subjects: CreateSubjectPayload[]): Promise<Subject[]> {
    try {
      const response = await privateApiClient.post<{
        data: Subject[];
        message: string;
        success: boolean;
      }>("/subjects/batch", { subjects });
      return response.data.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  }

  /**
   * Update multiple subjects in batch.
   */
  async batchUpdate(subjects: UpdateSubjectPayload[]): Promise<Subject[]> {
    try {
      const response = await privateApiClient.put<{
        data: Subject[];
        message: string;
        success: boolean;
      }>("/subjects/batch", { subjects });
      return response.data.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  }

  /**
   * Delete multiple subjects in batch.
   */
  async batchDelete(ids: number[]): Promise<void> {
    try {
      await privateApiClient.delete("/subjects/batch", { data: { ids } });
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  }
}

export default new SubjectService();
